// Pricing tiers for the `/pricing` page — Starter / Growth / Pro.
//
// Prices are per location, per month, VAT excluded. Yearly prices are the full
// annual charge (10 × monthly — "2 months free"), stored explicitly rather than
// computed so the rounding stays under our control.
//
// Currency follows the locale: RO → RON, everything else → EUR (same mapping as
// `src/lib/pricing.js`).

export const PLAN_IDS = ["starter", "growth", "pro"];

// The tier most venues should land on — gets the "most popular" treatment.
export const FEATURED_PLAN = "growth";

const PRICES = {
  RON: {
    currency: "RON",
    // Number first, then the currency ("249 RON") — matches the RO convention
    // used elsewhere on the site.
    symbolFirst: false,
    symbol: "RON",
    starter: { monthly: 99, yearly: 990, wasMonthly: 149, wasYearly: 1490 },
    growth: { monthly: 249, yearly: 2490 },
    pro: { monthly: 349, yearly: 3490 },
  },
  EUR: {
    currency: "EUR",
    symbolFirst: true,
    symbol: "€",
    starter: { monthly: 19, yearly: 190, wasMonthly: 29, wasYearly: 290 },
    growth: { monthly: 49, yearly: 490 },
    pro: { monthly: 69, yearly: 690 },
  },
};

// One icon per feature row, positionally matched to `pricing.plans.<id>.features`
// in the locale files. Kept out of i18n because the glyph is the same in every
// language — but the arrays must stay the same length as the translated lists.
export const FEATURE_ICONS = {
  starter: ["message", "star", "wand", "arrow-up-right", "bell", "chart", "globe", "phone", "plate"],
  growth: ["users", "arrow-up-right", "chart", "qr", "shield", "sparkles", "globe", "plate"],
  pro: ["user", "chart", "star", "card", "wand", "message", "menu-card", "globe", "plate"],
};

// The NFC-cards line is appended after the translated features on every plan.
export const CARDS_ICON = "card";

const LOCALE_TO_CURRENCY = { ro: "RON" };

export function pricesForLocale(locale) {
  return PRICES[LOCALE_TO_CURRENCY[locale] || "EUR"];
}

// Thousands separators follow the locale ("2.490" in RO, "2,490" in EN).
export function formatAmount(amount, cfg, locale) {
  let n;
  try {
    n = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(amount);
  } catch {
    n = String(amount);
  }
  return cfg.symbolFirst ? `${cfg.symbol}${n}` : `${n} ${cfg.symbol}`;
}
